import { ReactElement } from "react";
import { useLocalization } from "@fluent/react";
import { DrawerCard } from "../../common";
import getPaymentTypeDrawerConfig from "../paymentTypeDrawerConfig";
import type { PaymentMetadataProps } from "../PaymentActivityDrawer";

type RecipientDetailsCardProps = {
  paymentActivity: API.FormattedPaymentActivity;
  paymentMetadata: PaymentMetadataProps | null;
  drawerConfig: ReturnType<typeof getPaymentTypeDrawerConfig>;
};

const RecipientDetailsCard = ({
  paymentActivity,
  paymentMetadata,
  drawerConfig,
}: RecipientDetailsCardProps): ReactElement | null => {
  const { l10n } = useLocalization();

  if (
    !paymentActivity?.model ||
    (!paymentMetadata && !paymentActivity.isReversal)
  ) {
    return null;
  }

  const config = drawerConfig[paymentActivity.model];
  if (!config) return null;

  const rows = config.recipientDetailsRows(
    paymentActivity.recipient,
    paymentActivity,
    paymentMetadata ?? {},
  );

  return (
    <DrawerCard
      rows={rows.filter((row) => row[1])}
      title={l10n.getString("recipient-details")}
    />
  );
};

export default RecipientDetailsCard;
